import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSummaryImageProps } from '../@types/ProductSummaryImageProps';

export const ProductSummaryImageContext = createContext<ProductSummaryImageProps>({} as ProductSummaryImageProps);

ProductSummaryImageContext.displayName = 'ProductSummaryImage';

const ProductSummaryImageProvider = (props: ProductSummaryImageProps) => (
	<ProductSummaryImageContext.Provider value={props}>{props.children}</ProductSummaryImageContext.Provider>
);

export const useProductSummaryImage = () => {
	const context = useContext(ProductSummaryImageContext);

	return context;
};

export default ProductSummaryImageProvider;
